import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconGiftSvg } from "./IconGiftSvg.mjs";
const IconGift = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconGiftSvg, ...svgProps }) });
export {
  IconGift
};
